import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: (remainingDays: number) => string | React.ReactNode;
    detailsWithPermission: string;
    detailsNoPermission: string;
    cta: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Title showing days remaining in trial */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (remainingDays: number) => __intl__.intl().formatMessage({ id: "TrialAlertBanner.title?c=yptsogcu1c1d", defaultMessage: "Your Pro plan free trial ends in {remainingDays} {remainingDays, plural, one {day} other {days}}." }, { remainingDays: remainingDays }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message for billing managers */
            detailsWithPermission: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TrialAlertBanner.detailsWithPermission?c=32evnfiu7t9l1", defaultMessage: "Subscribe to keep using premium features and higher usage limits." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message for non-billing users */
            detailsNoPermission: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TrialAlertBanner.detailsNoPermission?c=1f4p9of3t17ng", defaultMessage: "Contact the account owner to upgrade account." }));
                },
                enumerable: true,
                configurable: true
            },
            /** CTA button text */
            cta: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TrialAlertBanner.cta?c=1r8jyiurm8uop", defaultMessage: "Subscribe now" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
